import {ReactElement} from 'react'
import {TablePagination} from '@material-ui/core'
import {PaginationApi} from '../../../shared/hooks/usePagination'
import {useStyles} from './styles'

type PaginationProps = {
  paginationApi: PaginationApi
  totalCount: number
}

export const Pagination = (props: PaginationProps): ReactElement | null => {
  const {paginationApi, totalCount} = props

  const classes = useStyles()

  const {offset, limit} = paginationApi.value

  const rowsPerPage = paginationApi.value.limit
  const page = Math.floor(offset / limit)

  const handlePageChange = (e: unknown, nextPage: number) => {
    const nextOffset = nextPage * limit
    paginationApi.change(nextOffset)
  }

  if (totalCount <= limit) return null

  return (
    <TablePagination
      component="div"
      classes={{root: classes.pagination, actions: classes.paginationActions}}
      count={totalCount}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[rowsPerPage]}
      page={page}
      onPageChange={handlePageChange}
    />
  )
}
